import { Alert, Form } from 'react-bootstrap'
import PropTypes, { array, string } from 'prop-types'
import LimitDisplay from '../LimitDisplay'
import { LabelFor } from './LabelFor.jsx'

export const Textarea = (props) => {
    const handleInputChange = (e, input = false, dirty) => {
        // TODO: input and dirty are not used
        if (input) return
        const reg = props.onlyNumbers && /^[0-9]+$|^$/
        if (props.onlyNumbers && !e.target.value.match(reg)) return
        if (props.limit) {
            e.target.value = e.target.value.slice(0, props.limit)
        } else {
            e.target.value = e.target.value.slice(0, 255)
        }
        const newValue = input ? e.target.value : e

        if (!input) {
            props.onChange(newValue)
        }
    }

    return (
        <>
            <Form.Group className={`w-100 ${props.className || ''}`}>
                <LabelFor
                    label={props.label}
                    id={props.id}
                    tooltipText={props.tooltipText}
                />
                <Form.Control
                    id={
                        props.id || props.name || props.ariaLabel || props.label
                    }
                    aria-label={props.name || props.ariaLabel || props.label}
                    title={props.title}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    as='textarea'
                    rows={props.rows}
                    onChange={(e) => handleInputChange(e, false, false)}
                    value={props.value || ''}
                />
                {!props.hideLimitter && props.limit && (
                    <LimitDisplay
                        limit={props.limit}
                        value={props.value}
                        float={props.limitterFloat || 'end'}
                    />
                )}
                {props.errorText && (
                    <Alert className={'p-1 w-100'} variant={'danger'}>
                        <div className={'ms-1'}> {props.errorText}</div>
                    </Alert>
                )}
            </Form.Group>
        </>
    )
}

Textarea.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    limit: PropTypes.number,
    hideLimitter: PropTypes.bool,
    onlyNumbers: PropTypes.bool,
    limitterFloat: PropTypes.oneOf(['end', 'start']),
    errorText: PropTypes.oneOfType([string, array]),
    rows: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    id: PropTypes.string,
    ariaLabel: PropTypes.string,
    name: PropTypes.string,
    labelClassName: PropTypes.string,
    tooltipText: PropTypes.string,
}
